<template>
    <div class="computerBox">
        <topBox :title="$route.meta.title" />
        <div class="px-[36px] w-full mt-[80px] pb-[70px]">

            <div class="rounded-[20px] border bg-white px-[20px] py-[12px] shadow-lg text-center mb-4">
                <div class="text-14 text-slate-400">{{ $t('text.redEnvelopeTotal') }}</div>
                <div class="mt-1 text-m14 font-semibold text-slate-900">{{ total }}</div>
            </div>

            <van-list
                v-model:loading="loading"
                :finished="finished"
                :immediate-check="true"
                :finished-text="$t('text.noMore')"
                @load="onLoad"
            >
                <div
                    v-for="item in list"
                    :key="item.red_envelope_id"
                    class="ticket-card"
                    :class="{ 'ticket-card--opened': isClaimed(item), 'ticket-card--revealing': item.revealing }"
                >
                    <div class="ticket-head">
                        <span class="ticket-badge">{{ $t('footer.TreasurePlate') }}</span>
                        <span class="ticket-no">#{{ item.red_envelope_id }}</span>
                    </div>

                    <!-- 金额区：未领取为待刮涂层，已领取露出金额 -->
                    <div class="scratch-stage">
                        <div class="amount-layer">
                            <div class="amount-label">{{ $t('text.redEnvelopePrize') }}</div>
                            <div class="amount-value">
                                <template v-if="isClaimed(item) && item.amount != null">
                                    <span class="currency">¥</span>{{ formatAmount(item.amount) }}
                                </template>
                                <template v-else>
                                    <span class="currency">¥</span>??.??
                                </template>
                            </div>
                        </div>

                        <div
                            v-if="!isClaimed(item) || item.revealing"
                            class="scratch-foil"
                            :class="{ 'scratch-foil--gone': item.revealing || isClaimed(item) }"
                        >
                            <div class="foil-shine"></div>
                            <div class="foil-mark">
                                <span class="foil-yen">¥</span>
                                <span class="foil-text">{{ $t('text.redEnvelopeScratchHint') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="ticket-meta fz12">
                        <div class="tfz12 text-slate-400">
                            {{ $t('text.redEnvelopeGrantTime') }}：{{ date(item.updated_at) }} {{ time(item.updated_at) }}
                        </div>
                        <div v-if="isClaimed(item)" class="mt-1 fz12 text-slate-400">
                            {{ $t('text.redEnvelopeClaimTime') }}：{{ date(item.created_at) }} {{ time(item.created_at) }}
                        </div>
                    </div>

                    <button
                        v-if="!isClaimed(item)"
                        type="button"
                        class="open-btn"
                        :disabled="claimingId === item.red_envelope_id"
                        @click="onClaim(item)"
                    >
                        {{ claimingId === item.red_envelope_id ? $t('text.buying') : $t('text.redEnvelopeOpen') }}
                    </button>
                    <div v-else class="opened-tag">{{ $t('text.redEnvelopeClaimed') }}</div>
                </div>
            </van-list>

            <div v-if="finished && list.length === 0" class="py-10 text-center text-sm text-slate-400">
                {{ $t('text.noRedEnvelopeRecords') }}
            </div>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import format from '@/assets/js/formatDate'
import postPages from '@/assets/js/postPages'
import axios from 'axios'
import { layer } from 'vue3-layer'

export default {
    components: {
        topBox,
        mainMenu,
    },
    setup() {
        return {
            ...format(),
        }
    },
    data() {
        return {
            lang: '',
            list: [],
            total: 0,
            pageNumber: 1,
            pageSize: 20,
            loading: false,
            finished: false,
            claimingId: 0,
        }
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
    },
    methods: {
        isClaimed(item) {
            return Number(item.status) === 1
        },
        formatAmount(amount) {
            const n = Number(amount)
            if (Number.isNaN(n)) return '0.00'
            return n.toFixed(2)
        },
        onLoad() {
            const page = postPages(
                this.lang,
                localStorage.getItem('token'),
                '/api/m/page/red-envelope',
                this.pageSize,
                this.pageNumber,
                ''
            )
            page.data.then((res) => {
                if (res && res.code === 0) {
                    const items = res.data.items || []
                    this.total = res.data.total || 0
                    items.forEach((item) => {
                        this.list.push({
                            ...item,
                            revealing: false,
                        })
                    })
                    this.loading = false
                    this.pageNumber++
                    if (this.list.length >= this.total) {
                        this.finished = true
                    }
                } else {
                    this.loading = false
                    this.finished = true
                    if (res) layer.msg(res.msg)
                }
            }).catch(() => {
                this.loading = false
                this.finished = true
            })
        },
        onClaim(item) {
            if (this.claimingId || this.isClaimed(item)) return
            this.claimingId = item.red_envelope_id

            axios.post(
                '/api/m/claim/red-envelope',
                { red_envelope_id: item.red_envelope_id },
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        token: localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                this.claimingId = 0
                if (response.data.code !== 0) {
                    layer.msg(response.data.msg)
                    return
                }
                const data = response.data.data || {}
                item.amount = data.amount
                item.status = data.status
                item.created_at = data.created_at
                item.revealing = true
                layer.msg(response.data.msg)
                setTimeout(() => {
                    item.revealing = false
                }, 900)
            })
            .catch((error) => {
                this.claimingId = 0
                console.log(error)
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
}

.ticket-card {
    position: relative;
    margin-bottom: 14px;
    padding: 16px;
    border-radius: 18px;
    background:
        linear-gradient(145deg, #fffdf8 0%, #ffffff 45%, #f7faf7 100%);
    border: 1px solid #e5e7eb;
    box-shadow: 0 8px 18px -8px rgba(15, 23, 42, 0.18);
    overflow: hidden;
}

.ticket-card::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 6px;
    background: linear-gradient(180deg, #16a34a, #86efac);
}

.ticket-card--opened {
    background: linear-gradient(145deg, #f0fdf4 0%, #ffffff 55%);
}

.ticket-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-left: 8px;
}

.ticket-badge {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #15803d;
}

.ticket-no {
    font-size: 11px;
    color: #94a3b8;
}

.scratch-stage {
    position: relative;
    height: 96px;
    border-radius: 14px;
    overflow: hidden;
    border: 1px dashed #cbd5e1;
    background: #fff;
}

.amount-layer {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background:
        radial-gradient(circle at 20% 20%, rgba(34, 197, 94, 0.12), transparent 45%),
        radial-gradient(circle at 80% 80%, rgba(250, 204, 21, 0.14), transparent 40%),
        #fffef8;
}

.amount-label {
    font-size: 11px;
    color: #64748b;
    letter-spacing: 0.12em;
}

.amount-value {
    margin-top: 4px;
    font-size: 28px;
    font-weight: 800;
    color: #166534;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.02em;
}

.currency {
    font-size: 18px;
    margin-right: 2px;
    font-weight: 700;
}

.scratch-foil {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background:
        repeating-linear-gradient(
            -35deg,
            #c0c7d1 0 8px,
            #d8dee7 8px 16px
        ),
        linear-gradient(135deg, #9aa3b2, #e8edf4 45%, #8b95a5);
    transition: opacity 0.75s ease, transform 0.75s ease, filter 0.75s ease;
}

.scratch-foil::after {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(rgba(255, 255, 255, 0.35) 1px, transparent 1px);
    background-size: 4px 4px;
    opacity: 0.45;
    pointer-events: none;
}

.foil-shine {
    position: absolute;
    top: -40%;
    left: -20%;
    width: 40%;
    height: 180%;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.55),
        transparent
    );
    transform: rotate(18deg);
    animation: foil-glint 2.4s ease-in-out infinite;
}

.foil-mark {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: #475569;
}

.foil-yen {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.55);
    border: 1px solid rgba(148, 163, 184, 0.8);
    font-size: 18px;
    font-weight: 800;
    color: #334155;
}

.foil-text {
    font-size: 11px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #334155;
    font-weight: 600;
}

.scratch-foil--gone {
    opacity: 0;
    transform: scale(1.06);
    filter: blur(2px);
    pointer-events: none;
}

.ticket-meta {
    margin-top: 12px;
    padding-left: 8px;
}

.open-btn {
    margin-top: 12px;
    width: 100%;
    padding: 12px 8px;
    border-radius: 9999px;
    border: none;
    background: linear-gradient(90deg, #16a34a, #22c55e);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 8px 16px -8px rgba(22, 163, 74, 0.7);
}

.open-btn:disabled {
    opacity: 0.65;
}

.opened-tag {
    margin-top: 12px;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #16a34a;
}

@keyframes foil-glint {
    0%,
    100% {
        left: -30%;
        opacity: 0.2;
    }
    50% {
        left: 90%;
        opacity: 0.85;
    }
}
</style>
